import { getGroupId } from "../base/conference";
import { isCheckPermission } from "../base/localuser";
import { PERMISSION } from "../base/participants";
import { toState } from "../base/redux";
import { getStartGroup } from "../group";
import { documentLayoutList, getCurrentMode, layoutList, videoLayoutMode } from "../video-layout-mode";
import { DEFAULT_DOCUMENT, DEFAULT_INDEX } from "./constants";

export function isRefresh(stateful) {
    const { refresh } = toState(stateful)['features/share-document'];
    return refresh;
}

export function getIsWhiteBoard(mode) {
    return videoLayoutMode.white === mode ? true : false;
}

export function isShareDocument(stateful) {
    const { isOpen } = toState(stateful)['features/share-document'];
    return Boolean(isOpen);    
}

export function getFilterDocumentListByMode(state, isWhiteBoard) {
    const storage = state['features/share-document'];

    const list = isWhiteBoard ? storage.whiteBoard : storage.document;
    return new Map(list.entries());
}

export function getDocumentListByArrayBufferPage(state, uuid) {
    const list = state['features/share-document'].arrayBufferList;
    return list ? list.get(uuid)?.page : null;
}

export function getFilterDocumentListByUuid(state, uuid, isWhiteBoard) {
    let list = isWhiteBoard ? state['features/share-document'].whiteBoard : state['features/share-document'].document;

    return list.get(uuid);
}

export function getFocusItem(state, isWhiteBoard) {
    if (isWhiteBoard) {
        const focusItem = state['features/share-document'].whiteFocus;

        return focusItem;
    } else return state['features/share-document'].documentFocus;
}

export function getFocusItemDocumentList(state, isWhiteBoard) {
    const { uuid, index } = getFocusItem(state, isWhiteBoard);

    if (uuid) {
        const list = getFilterDocumentListByUuid(state, uuid, isWhiteBoard);

        return {
            list,
            uuid,
            index
        }
    }

    return {
        list: null,
        uuid: null,
        index: null
    };
}

export function getFocusCanvasList(state, uuid, index) {
    const { canvasList } = state['features/share-document'];
    
    let line;
    const list = canvasList.get(uuid);
    if (list) line = list.get(String(index));
    return line;
}

export function getCanvasList(state, uuid) {
    const { canvasList } = state['features/share-document'];

    return canvasList.get(uuid);
}

export function getCanvasPage(state, uuid) {
    const list = state['features/share-document'].arrayBufferList;
    return list ? list.get(uuid)?.page : null;
}

export function getModeChangeList(state) {
    const permission = isCheckPermission(state, PERMISSION.SHARE);
    const mode = getCurrentMode(state);

    let list;
    let currentShare = false;
    if (permission) {
        if (mode === videoLayoutMode.white || mode === videoLayoutMode.document) {
            list = documentLayoutList;

            const focusList = getFocusItemDocumentList(state, getIsWhiteBoard(mode));
            if (focusList.list) currentShare = focusList;
        }
        
        if (documentLayoutList.indexOf(mode) !== -1) {
            list = documentLayoutList;
        } if (layoutList.indexOf(mode) !== -1) {
            const start = getStartGroup(state);
            list = layoutList;
            if (start) {
                list = [videoLayoutMode.grid, videoLayoutMode.pin, videoLayoutMode.seminar];
            }            
        }
    }

    return {
        list,
        mode,
        currentShare
    };
}